export enum ImageInspectionType {
  PASS = 'PASS',
  SCREENSHOT = 'SCREENSHOT',
  MONOTONE = 'MONOTONE',
}
